module.exports = __webpack_public_path__ + "static/media/CreditoyFinanciamiento.e30312ef.mp4";